import posthog from 'posthog-js';

export function initAnalytics() {
  if (process.env.REACT_APP_POSTHOG_KEY) {
    posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
      api_host: 'https://eu.posthog.com',
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: false,
      // Session recording is disabled here in code, not just in the PostHog
      // project settings, so it cannot be switched back on from the PostHog
      // UI without a deploy. Canvases hold confidential SME business data.
      disable_session_recording: true,
    });
  }
}

export function identifyUser(userId, email, businessName) {
  if (!process.env.REACT_APP_POSTHOG_KEY) return;
  posthog.identify(String(userId), { email, businessName });
}

export function resetUser() {
  if (!process.env.REACT_APP_POSTHOG_KEY) return;
  posthog.reset();
}

export function track(event, properties = {}) {
  if (!process.env.REACT_APP_POSTHOG_KEY) return;
  posthog.capture(event, properties);
}
